// PagSeguro API
(function () {
  'use strict';

  // Variáveis
  const urlApi = $('#form-pagseguro-api-ini').attr('action');
  const $btnSendCod = $('.psa-send-code-btn');
  const $btnValidateCod = $('.psa-validate-code-btn');
  const $inputMail = $('#psa_identificador');
  const $inputCode = $('#psa_sms_code');
  const $linkChangeAcc = $('.psa-change-acc');
  let codeTime;
  let codeResendTime;

  // Desabilita o envio dor form com a tecla Enter
  $('#form-pagseguro-api-ini').on('keyup keypress', function (ev) {
    const keyCode = ev.keyCode || ev.which;
    if (keyCode === 13) {
      ev.preventDefault();
      return false;
    }
  });

  // Ao clicar para enviar o código
  $btnSendCod.on('click', function (ev) {
    ev.preventDefault();
    $inputMail.parsley().validate();
    if ($inputMail.parsley().isValid()) {
      sendCodeSMS();
    }
  });

  // Habilita ou não o botão de validação ao digitar o código
  $inputCode.on('input', function () {
    if ($inputCode.val() != '' && $inputCode.val().length >= 6) {
      $btnValidateCod.prop('disabled', false);
    } else {
      $btnValidateCod.prop('disabled', true);
    }
  });

  // Ao clicar para validar o código
  $btnValidateCod.on('click', function (ev) {
    ev.preventDefault();
    if ($inputCode.parsley().isValid()) {
      validateCodeSMS();
    }
  });

  // Ao clicar para alterar a conta
  $linkChangeAcc.on('click', function (ev) {
    ev.preventDefault();
    showConfirm({
      type: 'warning',
      title: 'Atenção!',
      text: 'Ao alterar a conta, toda a configuração da conta atual será perdida. Clique em Confirmar para alterar a conta.',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        changeAccount();
      },
    });
  });

  // Envia o código SMS
  function sendCodeSMS() {
    codeResendTime = 0;
    clearInterval(codeTime);
    $inputCode.val('');
    $btnValidateCod.prop('disabled', true);
    $btnSendCod.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
    $.getJSON(`${urlApi}?acao=psa_sms&email=${$inputMail.val()}`, function (result) {
      console.log(result);
      $btnSendCod.prop('disabled', false).html('Solicitar código');
      if (result.status === 'success') {
        $btnSendCod.hide();
        $('.psa-phone').text(result['phone_number']);
        $('.psa-code-wrp').show();
        sendTimeCode(result['retry_after_seconds']);
      } else {
        Toast.fire({
          type: 'error',
          title: result.mensagem,
        });
      }
    }).fail(function (err) {
      console.log(err);
      $btnSendCod.prop('disabled', false).html('Solicitar código');
      Toast.fire({
        type: 'error',
        title: 'Não foi possível realizar esta operação.',
      });
    });
  }

  // Valida o código SMS
  function validateCodeSMS() {
    $btnValidateCod.prop('disabled', true).html('<div class="btn-spinner"></div> Aguarde');
    $.getJSON(`${urlApi}?acao=psa_auth&email=${$inputMail.val()}&code=${$inputCode.val()}`, function (result) {
      console.log(result);
      $btnValidateCod.prop('disabled', false).html('Validar código');
      if (result.status === 'success') {
        $('#modal-pagseguro-app-ini').modal('hide');
        Toast.fire({
          type: 'success',
          title: 'Autenticação realizada com sucesso!',
        });
        $('#psa_identificador2').val($inputMail.val());
        $('#psa_status').prop('checked', true);
        setTimeout(() => {
          $('#modal-pagseguro-app').modal('show');
        }, 1000);
      } else {
        Toast.fire({
          type: 'error',
          title: result.mensagem,
        });
      }
    }).fail(function (err) {
      console.log(err);
      $btnValidateCod.prop('disabled', false).html('Validar código');
      Toast.fire({
        type: 'error',
        title: 'Não foi possível validar o código.',
      });
    });
  }

  // Contador do tempo para reenviar o código
  function sendTimeCode(seconds) {
    codeResendTime = seconds;
    $('.psa-msg-resend').show();
    $('.psa-msg-resend b').text(codeResendTime + ' segundos');
    codeTime = setInterval(() => {
      codeResendTime--;
      if (codeResendTime > 0) {
        $('.psa-msg-resend').show();
        $('.psa-msg-resend b').text(codeResendTime + ' segundos');
      } else {
        $('.psa-msg-resend').hide();
        $btnSendCod.show();
        clearInterval(codeTime);
      }
    }, 1000);
  }

  // Altera a conta
  function changeAccount() {
    codeResendTime = 0;
    clearInterval(codeTime);
    $inputCode.val('');
    $inputMail.val('');
    $('#modal-pagseguro-app').modal('hide');
    $('#modal-pagseguro-app-ini').modal('show');
    $('.psa-code-wrp').hide();
    $btnSendCod.show();
  }
})();

// Parcelamento e Juros
(function () {
  'use strict';
  $('.pay-parc-juros-wrp').each(function () {
    // Variáveis
    const $tableWrp = $(this);
    const $tableList = $tableWrp.find('tbody');
    const $inputParc = $($tableWrp.data('ipq'));
    const $inputParcSemJuros = $($tableWrp.data('ipsj'));
    const jurosAtuais = $tableWrp.data('juros') || [];

    // Ao alterar o número de parcelas
    $inputParc.on('change', populaTabela);
    $inputParcSemJuros.on('change', populaTabela);

    // Popula tabela
    function populaTabela() {
      const numParc = $inputParc.val();
      const numParcSj = $inputParcSemJuros.val();
      $tableList.html('');
      for (let i = 1; i <= numParc; i++) {
        const jurosCur = jurosAtuais[i] ? jurosAtuais[i] : 0;
        const jurosEnable = i <= numParcSj ? 'readonly' : '';
        const jurosValue = i <= numParcSj ? 0 : jurosCur;
        $tableList.append(`
        <tr>
          <td><div class="truncate-text mt-2"><b>${i}ª - Parcela</b></div></td>
          <td>
            <div class="row">
              <div class="col-8 col-md-5">
                <div class="form-group sm mb-0">
                  <div class="input-group">
                    <input type="text" name="settings[juros_parcelas][${i}]" inputmode="numeric" class="form-control percent" data-input-default="0" data-parsley-trigger="change" placeholder="0" value="${jurosValue}" ${jurosEnable}>
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>`);
      }
      initInputMask();
    }
  });
})();
